import { render, staticRenderFns } from "./ComplaintFollowUpUpdate.vue?vue&type=template&id=d2ae9bba&"
import script from "./ComplaintFollowUpUpdate.vue?vue&type=script&lang=js&"
export * from "./ComplaintFollowUpUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports